/**
 * Renders a form view allowing modification of the given `Plugin`.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `Plugin` model associated with the view.
 * inputViews | A mapping from field `id` to the `FormInputView` representing the field.
 * @module app/views/admin/applications/Form
 */
import Backbone from "backbone";
import _ from "underscore";
import Field from "core/models/Field";
import Plugin from "app/models/Plugin";
import HtmlUtils from "html-utils";
import $ from "jquery";
import FormInputView from "core/views/FormInputView";
import viewTemplate from "views/admin/plugins/Form";
import ErrorUtils from "app/utils/ErrorUtils";
import Helper from "app/ejs";
import messenger from "app/Messenger";
export default Backbone.View.extend({
  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {Plugin} options.model The model to display.
   */
  initialize: function (options) {
    this.options = options;

    this.model = this.options.model;
    this.inputViews = {};
  },

  tagName: "form",
  className: "application-form",

  attributes: {
    class: "form-horizontal",
    enctype: "multipart/form-data",
  },

  events: {
    "click .show-secret": function () {
      this.$(".secret").attr("type", "text");
    },
    "click .reset-secret": function () {
      this.model
        .resetSecret()
        .fail(
          ErrorUtils.errorHandler({
            activity: "resetting the secret",
          })
        )
        .done(function () {
          messenger.success("Secret reset successfully.");
        })
        .always(
          _.bind(function () {
            this.render();
          }, this)
        );
    },
  },

  template: Helper.template(viewTemplate),

  render: function () {
    this.$el.html(this.template(this.options));
    var before = [
      new Field(Plugin.fields["Name"]),
      new Field(Plugin.fields["Domain"]),
    ];
    var after = [
      new Field(Plugin.fields["menuName"]),
      new Field(Plugin.fields["adminMenuName"]),
      new Field(Plugin.fields["mapName"]),
      new Field(Plugin.fields["type"]),
      new Field(Plugin.fields["slug"]),
      new Field(Plugin.fields["stylesheet"]),
      new Field(Plugin.fields["Status"]),
    ];

    var beforeEl = this.$(".before");
    var afterEl = this.$(".after");

    _.each(
      before,
      function (item) {
        var view = this._createInputView(this.model, item);

        view.render();
        beforeEl.before(view.$el);
      },
      this
    );

    _.each(
      after,
      function (item) {
        var view = this._createInputView(this.model, item);

        view.render();
        afterEl.after(view.$el);
      },
      this
    );

    HtmlUtils.bindAll(this.model, _.bind(this.$, this), {
      ".key": "ApplicationKey",
      ".secret": "Secret",
    });
  },

  /**
   * Resets the form fields.
   */
  reset: function () {
    this.$el.reset();
  },

  /**
   * Propagate form values to model fields.
   * @return {Promise} A promise object which shall resolve if the propagation is successful or reject with an error.
   */
  propagate: function () {
    return $.when();
  },

  /**
   * Commits all field values and submits the form via AJAX.
   * @return {Promise}          A promise object which shall resolve if the submission is successful or reject if it is not.
   */
  save: function () {
    var defer = new $.Deferred();

    this.propagate().done(
      _.bind(function () {
        this.model.save(null, {
          success: _.bind(defer.resolve, defer),
          error: _.bind(defer.reject, defer),
        });
      }, this)
    );

    return defer.promise();
  },

  _createInputView: function (model, field, prefix) {
    prefix = prefix || "";
    var defaultOptions = {
      name: prefix + "[" + field.attributes.name + "]",
      model: model,
      field: field,
    };

    var itemView = new FormInputView(defaultOptions);

    this.inputViews[field.id] = itemView;

    return itemView;
  },

  delegateEvents: function () {
    Backbone.View.prototype.delegateEvents.apply(this, arguments);
    _.each(this.inputViews, function (inputView) {
      inputView.delegateEvents();
    });
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/applications/Form.js
// module id = 933
// module chunks = 1